
import { i18nText } from '@/locales';

import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { Button, DatePicker, FormModel, Input, Row, Select } from "ant-design-vue";
import { clientDataMix } from "@/UI/components/clients/mixins/clientDataMix";
import { FormLayoutMix } from "@/UI/mixins/Layouts/Form";
import moment from "moment";
import { SourcesMix } from "@/UI/mixins/SourcesMix";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { getStudioId } from "@/UI/lib/state";
import { ClientsStore } from "@/store/modules/Clients";
import { RouterNameEnum } from "@/router/router.types";
import { ICategoryRepo } from "@/entity/category/category.types";
import { ClientCategoryStore } from "@/store/modules/ClientsCategory";
import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";

@Component({
    components: {
        BaseDataForm,
        PageTitle,
        "a-input": Input,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-row": Row,
        "a-button": Button,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
        "a-date-picker": DatePicker,
        "a-textarea": Input.TextArea,
    },
    methods: { moment },
})
export default class CreateClient extends mixins(
    SimpleProxyForm,
    clientDataMix,
    FormLayoutMix,
    SourcesMix,
    ProxyTableData
) {

    async clientCreate(): Promise<void> {
        (this.$refs.clientData as FormModel).validate(async (valid) => {
            if (valid) {
                try {
                    const response: any = await ClientsStore.create(this.clientFormData);
                    this.$message.open({type: response.status ? 'success' : 'error', content: response.response});
                    if (response.status) {
                        await this.$router.push({name: RouterNameEnum.Clients, params: {Studio: getStudioId(this)}});
                    }
                } catch (e) {
                    this.$notification.open({
                        message: i18nText("Клиент не создан"),
                        description: "",
                        duration: 10,
                    });
                    console.log(e);
                }
            }
        });
    }

    async created(): Promise<void> {
        console.clear()
        this.formReady = false
        this.clientFormData.salon_id = getStudioId(this);
        try {
            await this.fetchModule([
                { s: 'category', p: {} },
                { s: 'sources', p: {} },
            ])
        } catch (e) {
            console.log(e)
        } finally {
            this.formReady = true
        }
    }

    get category(): ICategoryRepo | null { return ClientCategoryStore.category }
}
